module.exports = __webpack_public_path__ + "media/images/icon__facebook-e1e8943db291e263e23483a0d0af5a6b.png";